import { css } from 'styled-components';
import { colors } from '../../constants/Colors';
import { TypesButton } from '../../constants/ButtonTypes';

const colorByType: Record<string, string> = {
    [TypesButton.PRIMARY]: colors.grey20,
    [TypesButton.SECONDARY]: colors.light,
    [TypesButton.DELETE]: colors.light,
};

export const applyDisabledBgColor = ({ typeButton, disabled }: { typeButton: TypesButton, disabled?: boolean }) => (
    disabled && (css`
          background: ${colorByType[typeButton]};
    `)
);
